// Menu Dropdown on Mouse Hover
let menuItems = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
menuItems.forEach((menuItem) => {
  menuItem.addEventListener("mouseover", () => {
    menuItem.setAttribute("open", true);
    menuItem.querySelector("ul").addEventListener("mouseleave", () => {
      menuItem.removeAttribute("open");
    });
    menuItem.addEventListener("mouseleave", () => {
      menuItem.removeAttribute("open");
    });
  });
});

// Tabs Sliders

const tabSliders = document.querySelectorAll(".echo-tabs-slider");
tabSliders.forEach((tabsSlider) => {
  const slider = tabsSlider.querySelector(".swiper-slider");
  const thumbs = tabsSlider.querySelector(".swiper-thumbs");

  var swiperThumbs = new Swiper(thumbs, {
    spaceBetween: 10,
    freeMode: true,
  });

  var swiperSlider = new Swiper(slider, {
    spaceBetween: 10,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    effect: "fade",
    thumbs: {
      swiper: swiperThumbs,
    },
  });
});

// Image Carousels

const imageCarousels = document.querySelectorAll(".js-echo-image-carousel");
imageCarousels.forEach((imageCarousel) => {
  const slider = imageCarousel.querySelector(".swiper-slider");
  const slidesPerViewDes = imageCarousel.getAttribute("data-slidesPerViewDes");
  const slidesPerViewMb = imageCarousel.getAttribute("data-sliderPerViewMb");
  const slidespaceBetween = imageCarousel.getAttribute("data-spaceBetween");

  var swiperSlider = new Swiper(slider, {
    spaceBetween: slidespaceBetween,
    slidesPerView: slidesPerViewMb,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: slidespaceBetween,
      },
      1024: {
        slidesPerView: slidesPerViewDes,
        spaceBetween: slidespaceBetween,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
    },
  });
});

// Product Carousels

var swiperThumb = new Swiper(".product__media-thumbnails", {
  spaceBetween: 5,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
  mousewheel: true,
  breakpoints: {
    1024: {
      direction: "vertical",
    },
  },
  navigation: {
    nextEl: ".swiper-button-next-thumb",
    prevEl: ".swiper-button-prev-thumb",
  },
});
var swiperMedia = new Swiper(".product__media-gallery", {
  spaceBetween: 10,
  pagination: {
    el: ".product__media-fraction.swiper-pagination",
    type: "fraction",
  },
  thumbs: {
    swiper: swiperThumb,
  },
});

// bundle-tabs
document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("tab-container")) {
    class TabContainer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const tabButtons = this.querySelectorAll(".tab-button");
        const productCountElement = this.querySelector(".product--counter");

        // Function to update product count
        const updateProductCount = () => {
          const activeTabContent = this.querySelector(".tab-content.is-active");
          const productItems = activeTabContent
            ? activeTabContent.querySelectorAll(".product-item")
            : [];
          const productCount = productItems.length;

          // Update the product count display
          if (productCountElement) {
            productCountElement.textContent = productCount;
          }
        };

        // Initial count on page load
        updateProductCount();

        tabButtons.forEach((tabButton) => {
          const handleTabInteraction = (event) => {
            event.stopPropagation();
            const currentTabContentId =
              tabButton.getAttribute("data-tab-content");
            const currentTabContent = this.querySelector(currentTabContentId);

            // Remove 'is-active' class from all tab buttons
            tabButtons.forEach((button) => {
              button.classList.remove("is-active");
            });

            // Add 'is-active' class to the clicked tab button
            tabButton.classList.add("is-active");

            // Remove 'is-active' class from all tab contents
            this.querySelectorAll(".tab-content").forEach((tabContent) => {
              tabContent.classList.remove("is-active");
            });

            // Add 'is-active' class to the corresponding tab content
            currentTabContent.classList.add("is-active");

            // Update product count when tab changes
            updateProductCount();
          };

          // Attach both click and touch event listeners to the button
          tabButton.addEventListener("click", handleTabInteraction);
          tabButton.addEventListener("touchstart", handleTabInteraction);
        });

        const NestedtabButtons = this.querySelectorAll(".nested-tab-button");

        NestedtabButtons.forEach((tabButton) => {
          const handleTabInteraction = (event) => {
            event.stopPropagation();
            const currentTabContentId =
              tabButton.getAttribute("data-tab-content");
            const currentTabContent = this.querySelector(currentTabContentId);

            // Remove 'is-active' class from all nested tab buttons
            NestedtabButtons.forEach((button) => {
              button.classList.remove("is-active");
            });

            // Add 'is-active' class to the clicked nested tab button
            tabButton.classList.add("is-active");

            // Remove 'is-active' class from all nested tab contents
            this.querySelectorAll(".nested-tab-content").forEach(
              (tabContent) => {
                tabContent.classList.remove("is-active");
              }
            );

            // Add 'is-active' class to the corresponding nested tab content
            currentTabContent.classList.add("is-active");
          };

          // Attach both click and touch event listeners to the button
          tabButton.addEventListener("click", handleTabInteraction);
          tabButton.addEventListener("touchstart", handleTabInteraction);
        });
      }
    }

    customElements.define("tab-container", TabContainer);
  }

  const activateTabByHash = (hash) => {
    if (!hash) return;
    const tabButton = document.querySelector(
      `.tab-button[data-tab-content="${hash}"]`
    );
    const tabContent = document.querySelector(hash);
    if (tabButton && tabContent) {
      document
        .querySelectorAll(".tab-button, .tab-content")
        .forEach((el) => el.classList.remove("is-active"));
      tabButton.classList.add("is-active");
      tabContent.classList.add("is-active");

      setTimeout(() => {
        window.scrollTo({ top: tabButton.offsetTop - 100, behavior: "smooth" });
      }, 50);
    }
  };

  if (window.location.hash) activateTabByHash(window.location.hash);
  window.addEventListener("hashchange", () =>
    activateTabByHash(window.location.hash)
  );

  document.querySelectorAll(".tab-button").forEach((button) => {
    button.addEventListener("click", (e) => {
      const target = button.getAttribute("data-tab-content");
      if (target) {
        e.preventDefault();
        const formattedTarget = target.startsWith("#") ? target : `#${target}`;
        history.pushState(null, null, formattedTarget);
      }
    });
  });
});

// Bundle ATC

document.addEventListener("DOMContentLoaded", () => {
  const bundleProductItems = document.querySelectorAll(".bundle-product_item");
  const cartItemContainer = document.querySelector(
    ".bundle_products--cart-item"
  );
  const cartCountElement = document.querySelector(".bundle_cart--count");
  const cartTotalElement = document.getElementById("bundle_cart-total-price");
  const checkoutButton = document.getElementById("bundle_cart-checkout-btn");
  let selectedProducts = loadCartFromLocalStorage();

  function formatCurrency(value) {
    return `$${(value / 100).toFixed(2)}`;
  }

  function getProductData(item) {
    const productDataRaw = item.dataset.product;
    const parsedData = JSON.parse(productDataRaw);
    const {
      id: productId,
      title: name,
      price,
      compare_at_price,
      featured_image,
      variants,
    } = parsedData;

    return {
      productId,
      name,
      price: parseFloat(price),
      compare_at_price: compare_at_price ? parseFloat(compare_at_price) : NaN,
      productImage: featured_image,
      variantId: variants[0]?.id,
      quantity: 1,
    };
  }

  // Load cart from localStorage
  function loadCartFromLocalStorage() {
    const storedProducts = localStorage.getItem("selectedProducts");
    return storedProducts ? JSON.parse(storedProducts) : [];
  }

  // Save cart to localStorage
  function saveCartToLocalStorage() {
    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
  }

  // Clear cart and update storage
  function clearCart() {
    selectedProducts = [];
    saveCartToLocalStorage(); // Clear local storage
    renderCart();
  }

  // Calculate and update the total item count in the cart
  function updateCartCount() {
    const totalItems = selectedProducts.reduce(
      (count, item) => count + item.quantity,
      0
    );
    cartCountElement.innerText = totalItems;
  }

  // Add a product to the cart or increase its quantity if it already exists
  function addToCart(product) {
    const existingProduct = selectedProducts.find(
      (item) => item.productId === product.productId
    );
    if (existingProduct) {
      existingProduct.quantity++;
    } else {
      selectedProducts.push({ ...product });
    }
    saveCartToLocalStorage();
    renderCart();
  }

  // Render the cart display
  function renderCart() {
    cartItemContainer.innerHTML = "";
    updateCartCount();

    let total = 0;
    selectedProducts.forEach((item) => {
      const cartItem = document.createElement("div");
      cartItem.classList.add("bundle_cart--item");
      const showComparePrice =
        !isNaN(item.compare_at_price) &&
        item.compare_at_price !== null &&
        item.compare_at_price !== undefined &&
        item.compare_at_price !== item.price;

      const priceCompareClass = showComparePrice ? "text-decoration" : "";
      cartItem.innerHTML = `
        <img src="${item.productImage}" alt="${
        item.name
      }" class="cart_item-media"/>
        <div class="cart_item-content">
        <div class="cart_item-title_price">
        <h4 class="cart_item-title h5">${item.name}</h4>
                <div class="cart_price_compare">
                ${
                  showComparePrice
                    ? `<p class="compare-price">
                       ${formatCurrency(item.price * item.quantity)}
                      </p>`
                    : ""
                }
        <p class="${priceCompareClass}">
       ${formatCurrency(item.compare_at_price * item.quantity)}
      </p>
                 
</div>
</div>

        <div class="bundle_cart-quantity">
          <button data-id="${
            item.productId
          }" data-action="decrease" class="quantity-btn quantity-btn_minus">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg> 
          </button>
          <input name="quantity" value="${
            item.quantity
          }" class="quantity_input">
          <button data-id="${
            item.productId
          }" data-action="increase" class="quantity-btn quantity-btn_plus">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>
          </button>
        </div>
        </div>
      `;
      cartItemContainer.appendChild(cartItem);
      total += item.price * item.quantity;
      if (showComparePrice) {
        total += item.compare_at_price * item.quantity;
      }
    });

    cartTotalElement.textContent = formatCurrency(total);
    addQuantityButtonListeners();
    updateAddButtonsState();

    recommendedProductBundle();
  }

  function updateAddButtonsState() {
    bundleProductItems.forEach((item) => {
      const productData = getProductData(item);
      const bundleButton = item.querySelector(".product-item-button");
      const bundleButtonText = bundleButton.querySelector(".button_text");
      const isInCart = selectedProducts.some(
        (product) => product.productId === productData.productId
      );

      if (isInCart) {
        bundleButtonText.innerText = "+ Added";
        bundleButton.disabled = true;
      } else {
        bundleButtonText.innerText = "+ Add";
        bundleButton.disabled = false;
      }
    });
  }

  function addQuantityButtonListeners() {
    document
      .querySelectorAll(".bundle_cart-quantity button")
      .forEach((button) => {
        button.addEventListener("click", function () {
          const productId = this.getAttribute("data-id");
          const action = this.getAttribute("data-action");
          const product = selectedProducts.find(
            (item) => item.productId == productId
          );

          if (action === "increase") {
            product.quantity++;
          } else if (action === "decrease") {
            product.quantity > 1
              ? product.quantity--
              : (selectedProducts = selectedProducts.filter(
                  (item) => item.productId != productId
                ));
          }

          saveCartToLocalStorage();
          renderCart();
        });
      });
  }

  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

  function addSelectedProductsToShopifyCart() {
    const formData = {
      items: selectedProducts.map((product) => ({
        id: product.variantId,
        quantity: product.quantity,
      })),
    };

    if (cart) {
      formData.sections = cart
        .getSectionsToRender()
        .map((section) => section.id);
      formData.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        clearCart();
        // console.log(data);
        // cart.renderContents(data);
        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Error adding items to cart:", error);
      })
      .finally(() => {
        if (cart && cart.classList.contains("is-empty"))
          cart.classList.remove("is-empty");
      });
  }

  checkoutButton.addEventListener("click", () => {
    if (selectedProducts.length > 0) {
      addSelectedProductsToShopifyCart();
    } else {
      alert("Cart is empty!");
    }
  });

  bundleProductItems.forEach((item) => {
    const bundleButton = item.querySelector(".product-item-button");
    bundleButton.addEventListener("click", () => {
      const productData = getProductData(item);
      addToCart(productData);
      updateAddButtonsState();
    });
  });

  renderCart();

  function recommendedProductBundle() {
    const bundleDataElement = document.getElementById(
      "bundle_recommend-product-data"
    );
    const bundleData = JSON.parse(bundleDataElement.textContent);
    const selectedProducts = loadCartFromLocalStorage();

    console.log("Selected Products:", selectedProducts);

    let productArray = bundleData.bundleUpsell
      .map((product) => {
        const productTitle = Object.keys(product)[0];
        const productData = product[productTitle];

        return {
          id: productData.id,
          variantId: productData.variants[0]?.id || null,
          title: productTitle,
          price: productData.price,
          compare_at_price: productData.compare_at_price,
          featuredImage: productData.featured_image,
          url: `/products/${productData.handle}`,
        };
      })
      .filter((product) => {
        return !selectedProducts.some(
          (selected) => selected.productId === product.id
        );
      });

    const gridContainer = document.querySelector(".bundle_recommended--grid");
    if (!gridContainer) {
      console.error("Grid container not found");
      return;
    }
    const maxProductsToShow = 3;
    gridContainer.innerHTML = "";
    productArray.slice(0, maxProductsToShow).forEach((product) => {
      const comparePriceHTML = product.compare_at_price
        ? `<p class="bundle_product-compare-price text-decoration">${formatCurrency(
            product.compare_at_price
          )}</p>`
        : "";
      const priceCompareClass = comparePriceHTML ? "text-decoration" : "";
      const productHTML = `
      <div class="bundle_recommended-product-item" data-product-id="${
        product.id
      }" data-variant-id="${product.variantId}">
        <div class="bundle_recommended-product-wrapper">
          <div class="product-wrapper-img">
            <img src="${product.featuredImage}" alt="${
        product.title
      }" class="product-image">
          </div>
          <div class="bundle_recommended-item_inner">
            <span class="recommended-subtitle">Recommended</span>
            <div class="recommended-item_inner_price">
              <h5 class="bundle_product-title h6">${product.title}</h5>
              <div class="recommended_price_compare">
                ${formatCurrency(product.price)}
                <p class="bundle_product-price ${priceCompareClass}">${comparePriceHTML}</p>
              </div>
            </div>
            <button class="bundle_recommended-product-button button" data-product-id="${
              product.id
            }">
              Add to cart
            </button>
          </div>
        </div>
      </div>
    `;
      gridContainer.innerHTML += productHTML;
    });

    // Add event listeners for all product buttons
    document
      .querySelectorAll(".bundle_recommended-product-button")
      .forEach((button) => {
        button.addEventListener("click", (event) => {
          const productId = button.getAttribute("data-product-id");
          console.log("Clicked Product ID:", productId);

          // Find the product in the productArray
          const productData = productArray.find(
            (product) => String(product.id) === productId
          );

          if (productData) {
            const productToAdd = {
              productId: productData.id,
              variantId: productData.variantId,
              name: productData.title,
              price: productData.price,
              compare_at_price: productData.compare_at_price,
              productImage: productData.featuredImage,
              quantity: 1,
            };

            console.log("Product added to cart:", productToAdd);

            // Add the product to the cart
            addToCart(productToAdd);

            // Update the cart display
            renderCart();
          } else {
            console.error("Product data not found for ID:", productId);
            console.log("Current productArray:", productArray);
          }
        });
      });
  }

  recommendedProductBundle();
});

const players = Array.from(document.querySelectorAll(".js-player")).map(
  (p) => new Plyr(p)
);

// bannerSliders
const bannerSliders = document.querySelectorAll(".js-echo-banner-slider");

bannerSliders.forEach((bannerSlider) => {
  const slider = bannerSlider.querySelector(".swiper-slider");
  const slidesPerViewDes =
    parseInt(bannerSlider.getAttribute("data-slidesPerViewDes")) || 1;
  const slidesPerViewMb =
    parseInt(bannerSlider.getAttribute("data-sliderPerViewMb")) || 1;
  const slidespaceBetween =
    parseInt(bannerSlider.getAttribute("data-spaceBetween")) || 0;

  new Swiper(slider, {
    spaceBetween: slidespaceBetween,
    slidesPerView: slidesPerViewMb,
    pagination: {
      el: slider.querySelector(".swiper-pagination"),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: slidesPerViewDes,
      },
    },
  });
});
